import React from 'react';

export default function Quote() {
  return (
    <main className="quote_main">
      <div className="quote">
        Lorem ipsum dolor sit amet consectetur adipisicing elit.&nbsp;
        Autem, labore ratione assumenda doloremque nobis tempore nesciunt,&nbsp;
        aperiam, in omnis fuga exercitationem? Maiores quia delectus quidem&nbsp;
        sequi aliquid voluptas excepturi laudantium?
      </div>
    </main>
  );
}
